import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-attempt";

/**
 * React.lazy com resiliência a chunks obsoletos.
 * Quando um deploy novo invalida os arquivos hasheados, o import dinâmico falha.
 * Tentamos novamente uma vez e, se persistir, recarregamos a página (apenas uma vez).
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      // Segunda tentativa: pode ter sido falha de rede momentânea.
      try {
        const mod = await factory();
        sessionStorage.removeItem(RELOAD_KEY);
        return mod;
      } catch (retryError) {
        const alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === "1";
        if (!alreadyReloaded) {
          sessionStorage.setItem(RELOAD_KEY, "1");
          window.location.reload();
          // Promessa pendente enquanto a página recarrega.
          return new Promise<{ default: T }>(() => {});
        }
        throw retryError;
      }
    }
  });
}
